import React, { useState } from "react"
import { Link, Navigate, useNavigate, useLocation } from "react-router-dom"
import { MdLock } from "react-icons/md"
import { Modal, Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { ToastContainer, toast } from "react-toastify"
type FontPickerProps = {
  fonts: { name: string; fontFamily: string; label: string }[]
  selectedFont: { name: string; fontFamily: string; label: string }
  setFont: (font: any) => void
  onColorClick: () => void // New function called when a color is clicked
}

export const FontPickerUnPremium: React.FC<FontPickerProps> = ({
  fonts,
  selectedFont,
  setFont,
  onColorClick,
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [upgrade, setUpgrade] = useState(false)
  const handleCloseUpgrade = () => {
    setUpgrade(false)
  }
  return (
    <>
      <div style={{ display: "flex", gap: "10px" }}>
        <span
          style={{
            border: "1px solid",
            minHeight: "28px",
            padding: "8px",
            fontFamily: "Noto Sans",
            borderRadius: "10px",
            fontSize: "14px",
            color: "#000",
            // fontWeight: selectedFont === font.fontFamily ? "700" : "500", // Bold for selected
            cursor: "pointer",
            borderColor: "#245192",
            // fontFamily: selectedFont,

            // backgroundColor:
            //   selectedFont === font.fontFamily ? "#F0F0F0" : "transparent",
          }}
          // onClick={() => setFont(font.fontFamily)}
        >
          Noto Sans
        </span>

        {fonts.slice(1, 10).map((font, idx) => (
          <span
            key={idx}
            style={{
              border: "1px solid",
              minHeight: "28px",
              padding: "8px",
              fontFamily: font.fontFamily,
              borderRadius: "10px",
              fontSize: "14px",
              color:
                selectedFont?.fontFamily === font.fontFamily
                  ? "#000"
                  : "#6a6a6a", // Selected font in black, others in light gray
              // fontWeight: selectedFont === font.fontFamily ? "700" : "500", // Bold for selected
              cursor: "pointer",
              borderColor:
                selectedFont?.fontFamily === font.fontFamily
                  ? "#245192"
                  : "#cecccc",
              // fontFamily: selectedFont,

              // backgroundColor:
              //   selectedFont === font.fontFamily ? "#F0F0F0" : "transparent",
            }}
            onClick={onColorClick}
          >
            {font.label}
            <MdLock
              style={{
                width: "12.89px",
                height: "12.89px",
              }}
            />
          </span>
        ))}
      </div>
    </>
  )
}
